<template>
  <v-skeleton-loader
    :loading="isLoading"
    type="article"
  >
    <FormCanningProcess
      :CanningProcess="editCanningProcess"
      :isSaving="isSaving"
      :isCompleted="isCompleted"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormCanningProcess from '../components/FormCanningProcess.vue';
import checklist from './checklist';
import formatting from '../mixins/formatting';
import stockItem from './stockItem';

export default {
  components: {
    FormCanningProcess,
  },
  name: 'EditCanningProcess',
  module: 'CanningProcess',
  mixins: [checklist, formatting, loading, stockItem],
  data() {
    return {
      /**
      * Get/Set editing CanningProcess. Default to {}.
      */
      editCanningProcess: {},
      /**
       * Query Id for CanningProcess
       */
      canningProcessId: this.$route?.query.id,
      /** Get the mode for this view, create or update
      */
      mode: 'add',
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('canningProcesses', ['canningProcesses', 'canningProcess']),
  },
  destroyed() {
    this.$off('stockItem.loaded');
  },
  async mounted() {
    this.$on('stockItem.loaded', (item) => {
      this.isLoading = true;
      if (item.canningProcesses?.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.editCanningProcess = item.canningProcesses[0];
        this.mode = 'edit';
      } else {
        this.editCanningProcess.stockItemId = item.id;
        this.editCanningProcess.productionCode = this.formatProductionCode(item);
        console.debug(item.deliveryNote.farm);
        this.editCanningProcess.batchCodes = item.deliveryNote.farm.farmCode;
        this.$log.info('Prepopulation completed');
        this.$forceUpdate();
        this.mode = 'add';
      }
      this.isLoading = false;
    });
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('canningProcesses', ['LOAD_canningProcess', 'CREATE_canningProcess', 'UPDATE_canningProcess']),
    /** Method used to save the item
     */
    async save(canningProcess) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_canningProcess(canningProcess);
      } else {
        await this.UPDATE_canningProcess(canningProcess);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListFactoryItem' });
    },
  },
};
</script>

<docs>
# EditCanningProcess example

'''js
<EditCanningProcess :CanningProcess="CanningProcess" />
'''
</docs>
